enum PubSubEventRegistrationActionEnum
{
	REGISTERED = "registered",
	UNREGISTERED = "unregistered",
	REFUNDED = "refunded",
}

export default PubSubEventRegistrationActionEnum;
